import { useState, useCallback } from "react";

export const usePopper = initialState => {
    const [anchorEl, setAnchorEl] = useState(initialState.anchorEl);
    const [open, setOpen] = useState(initialState.open);
  
    const toggle = useCallback(
        (e) => {
            if (e !== null && e !== false) {
                setAnchorEl(e.currentTarget);
                setOpen(true);
            } else {
                setOpen(false);
            }
        },
        []
    );

    return [open, anchorEl, toggle];
};